// extracted by mini-css-extract-plugin
export default {"gap":".5em","theme":"#28a86e","button":"Button_button__c0lXg","icon":"Button_icon__hGai7","pointerEvents":"Button_pointerEvents__sPxJE"};